export default __webpack_public_path__ + "static/media/sharanya_core.4d40a2d9.jpg";